const Warning = (props) => (
    <div className="planCardButton-warning">
      { (props.warningLink == undefined) ?
        <span>
          <span className="fs-15 mr-5 custom-glyphicon icon-alert"></span>
          {props.text}
        </span> :
        <a target="_top" href={props.warningLink}>
          <span>
            <span className="fs-15 mr-5 custom-glyphicon icon-alert"></span>
            {props.text}
          </span>
        </a> 
      }
    </div>
);

Warning.propTypes = {
  text: React.PropTypes.string.isRequired,
  warningLink: React.PropTypes.string,
};

module.exports = Warning;
 



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/warning.jsx